/* eslint-disable */
import {Service} from 'components/Shared/server';
import {KnowledgebaseMediaResponse} from 'models/KnowledgebaseMediaResponse';


export const routeGetGetImageUrl = (mediaId: string) => `/api/knowledgebase/getimage?mediaId=${encodeURIComponent(mediaId)}`;
export function getGetImageUrl(mediaId: string): Promise<KnowledgebaseMediaResponse> {
  return Service.get<KnowledgebaseMediaResponse>({
    url: routeGetGetImageUrl(mediaId)
  });
}
